import { Injectable } from '@angular/core';
import { ChallengeBodyTeam } from '@skyfit/core-data-library';

@Injectable({
  providedIn: 'root',
})
export class AdminChallengeTeamsService {
  private readonly colors = [
    { hex: '#0055FF', name: 'Blue' },
    { hex: '#EC1337', name: 'Red' },
    { hex: '#FFBB00', name: 'Yellow' },
    { hex: '#26D962', name: 'Green' },
    { hex: '#6226D9', name: 'Purple' },
    { hex: '#FF1493', name: 'Pink' },
    { hex: '#C0C0C0', name: 'Silver' },
    { hex: '#FF5500', name: 'Orange' },
    { hex: '#EE82EE', name: 'Violet' },
    { hex: '#00FFFF', name: 'Aqua' },
    { hex: '#12682F', name: 'Jade' },
    { hex: '#4B0082', name: 'Indigo' },
    { hex: '#FFD700', name: 'Gold' },
    { hex: '#008080', name: 'Teal' },
    { hex: '#BE00BE', name: 'Magenta' },
    { hex: '#FF7F50', name: 'Coral' },
    { hex: '#9966CC', name: 'Amethyst' },
    { hex: '#0047AB', name: 'Cobalt' },
    { hex: '#DC143C', name: 'Crimson' },
    { hex: '#1560BD', name: 'Denim' },
    { hex: '#FF00FF', name: 'Fuchsia' },
  ];

  private readonly animals = [
    'Barracudas',
    'Cheetahs',
    'Chipmunks',
    'Ducks',
    'Giraffes',
    'Iguanas',
    'Jaguars',
    'Koalas',
    'Lions',
    'Lizards',
    'Monkeys',
    'Narwhals',
    'Pandas',
    'Parrots',
    'Penguins',
    'Rabbits',
    'Snakes',
    'Squirrels',
    'Tigers',
    'Wolves',
    'Zebras',
  ];

  randomName(): string {
    return this.animals[Math.floor(Math.random() * this.animals.length)];
  }

  randomColor(): { name: string; hex: string } {
    return this.colors[Math.floor(Math.random() * this.colors.length)];
  }

  randomTeam(): ChallengeBodyTeam {
    const name = this.randomName();
    const color = this.randomColor();
    const newTeam: ChallengeBodyTeam = {
      primaryColor: color.hex,
      name: `${color.name} ${name}`,
      theme: '',
      members: [],
    };
    return newTeam;
  }

  addTeam(teams: ChallengeBodyTeam[]): void {
    const newTeam = this.randomTeam();
    // Not likely but just in case we max out unique random teams.. don't loop forever.
    const maxTeams = this.animals.length * this.colors.length;
    while (
      teams.length < maxTeams &&
      teams.find((t) => t.name === newTeam.name)
    ) {
      const nextTeam = this.randomTeam();
      newTeam.name = nextTeam.name;
      newTeam.primaryColor = nextTeam.primaryColor;
    }
    teams.push(newTeam);
  }
}
